import financialClaimFA from './fa/fa.json'

const FinancialClaimMessages = {
  fa: { ...financialClaimFA },
}

export default FinancialClaimMessages
